import React from 'react';
import { Smartphone } from 'lucide-react';
import PageBreadcrumb from '../common/PageBreadcrumb';
import PageHeader from '../common/PageHeader';

const DeviceRegistration = () => {
  return (
    <>
      <PageBreadcrumb />
      <PageHeader 
        title="Device Registration"
        description="Register and manage mobile devices for secure access"
      />
      <div className="page-container">

        <div className="card-cam">
          <div style={{ textAlign: 'center', padding: '48px 24px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              borderRadius: 'var(--component-radius)',
              background: 'var(--primary-light)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              color: 'var(--primary-color)'
            }}>
              <Smartphone size={48} />
            </div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: 'var(--text-heading)',
              margin: '0 0 16px 0',
              fontFamily: 'var(--font-family)'
            }}>Mobile Device Management</h2>
            <p style={{
              color: 'var(--text-body)',
              margin: '0 0 32px 0',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto',
              fontFamily: 'var(--font-family)'
            }}>
              Register and manage mobile devices with secure access controls. 
              This feature will be available in v2.0.
            </p>
            
            <div style={{
              background: '#FEF3C7',
              border: '1px solid #FCD34D',
              borderRadius: 'var(--component-radius)',
              padding: '16px',
              marginBottom: '24px',
              maxWidth: '600px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>
              <p style={{
                color: '#92400E',
                fontSize: '14px',
                margin: 0,
                fontFamily: 'var(--font-family)'
              }}>
                <strong>Coming Soon:</strong> Mobile device management with registration, 
                security policies, and remote access controls.
              </p>
            </div>

            <button className="btn-cam" style={{ margin: '0 auto' }}>
              <Smartphone size={20} style={{ marginRight: '8px' }} />
              Register Device
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeviceRegistration;
